import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-tabs',
  template: `
    <app-tabs
      [links]="[
        {
          label: 'Données administratives',
          routerLink: '/administration/donnees',
          icon: 'far fa-file-pen',
        },
        {
          label: 'Paiement en ligne',
          routerLink: '/administration/paiement-en-ligne',
          icon: 'far fa-credit-card',
        },
      ]"
    ></app-tabs>
  `,
  standalone: false,
})
export class AdminTabsComponent {}
